export default "__VITE_ASSET__ac559d87__"